import classNames from 'classnames';
import React from 'react';
import { getCustomContrast, getBrandingColor } from '../utils/branding';

function CustomBrandedButton(props) {
  const { journey, children, className, style, ...restProps } = props;

  const bgColor = getBrandingColor(journey).hex;
  const contrast = getCustomContrast(bgColor);

  const fontColor = contrast === 'black' ? '#000000' : '#ffffff';

  const btnType = restProps.type || 'button';

  if (bgColor) {
    return (
      <button
        type={btnType}
        className={classNames('btn-bedrock-primary', className)}
        style={{
          backgroundColor: bgColor,
          color: fontColor,
          ...(style && { ...style }),
        }}
        {...restProps}
      >
        {children}
      </button>
    );
  } else {
    return (
      <button type={btnType} className='btn-bedrock-primary'>
        {children}
      </button>
    );
  }
}

export default CustomBrandedButton;
